import { parse, type SerializeOptions } from 'cookie';
import * as jose from 'jose';

export function generateRandomString(length: number): string {
  const charset = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let result = '';
  const randomValues = new Uint8Array(length);
  crypto.getRandomValues(randomValues);

  for (let i = 0; i < length; i++) {
    result += charset[randomValues[i] % charset.length];
  }
  return result;
}

export async function parseCookies(cookieHeader: string | null) {
  if (!cookieHeader) {
    return null;
  }

  const cookies = parse(cookieHeader);

  if (!cookies.userData) {
    return null;
  }

  const userData = await verifyCookieData(JSON.parse(cookies.userData!).userId);

  if (!userData) {
    return null;
  }

  return userData.userId;
}

export async function generateCookieData(userId: string) {
  console.log('[JWT] === Starting JWT Generation ===');
  console.log('[JWT] User data:', userId);

  const secret = new TextEncoder().encode(process.env.JWT_SECRET || 'your-secret-key-change-in-production');

  console.log('[JWT] JWT Secret:', process.env.JWT_SECRET ? 'Present' : 'Using default');

  const jwt = await new jose.SignJWT({
    userId,
  })
    .setProtectedHeader({ alg: 'HS256' })
    .setIssuedAt()
    .setExpirationTime('90d')
    .sign(secret);

  console.log('[JWT] JWT generated successfully');
  console.log('[JWT] JWT length:', jwt.length);
  console.log('[JWT] === JWT Generation Completed ===');

  return { userId: jwt };
}

export async function verifyCookieData(token: string) {
  console.log('[JWT] === Starting JWT Verification ===');
  console.log('[JWT] Token length:', token.length);

  try {
    const secret = new TextEncoder().encode(process.env.JWT_SECRET || 'your-secret-key-change-in-production');

    console.log('[JWT] JWT Secret for verification:', process.env.JWT_SECRET ? 'Present' : 'Using default');

    const { payload } = await jose.jwtVerify(token, secret);
    console.log('[JWT] JWT verification successful');
    console.log('[JWT] Payload:', payload);
    console.log('[JWT] === JWT Verification Completed ===');

    return payload as { userId: string };
  } catch (error) {
    console.error('[JWT] === JWT Verification Failed ===');
    console.error('[JWT] Error type:', error instanceof Error ? error.constructor.name : typeof error);
    console.error('[JWT] Error message:', error instanceof Error ? error.message : error);
    console.error('[JWT] Error stack:', error instanceof Error ? error.stack : 'No stack trace');

    if (error instanceof Error) {
      console.error('[JWT] Error name:', error.name);
      console.error('[JWT] Error code:', (error as any).code);
    }

    return null;
  }
}

export const userCookieSession: SerializeOptions = {
  path: '/',
  httpOnly: true,
  sameSite: 'lax',
  secure: process.env.NODE_ENV === 'production',
  maxAge: 1000 * 60 * 60 * 24 * 90, // 90 days
};
